import React, { memo, useEffect } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import PropTypes from 'prop-types';

import { isMobile } from '@common/utils/device';
import { getPdfWorkerJsFile } from '@common/utils/pdfHelper';
import useDrawablePdf from '@common/hooks/useDrawablePdf';
const PdfViewer = ({
  url,
  currentPage,
  handlePdfPageChange,
  pageNavigationPluginInstance,
  jumpToPagePluginInstance,
  zoomPluginInstance,
  enableLayout = false,
  isZoom = true,
}) => {
  const { onCanvasLayerRender, historyList, setHistoryList } = useDrawablePdf();
  const plugins = [
    jumpToPagePluginInstance,
    pageNavigationPluginInstance,
    { onCanvasLayerRender },
  ];
  isZoom && plugins.push(zoomPluginInstance);
  enableLayout && plugins.push(defaultLayoutPlugin());

  useEffect(() => {
    if(url && historyList) {
      setHistoryList(url);
    }
  }, [url, historyList]);

  return (
    <Worker
      workerUrl={getPdfWorkerJsFile(isMobile.any(), window.location.origin)}
    >
      <Viewer
        fileUrl={url}
        plugins={plugins}
        characterMap={{
          isCompressed: true,
          url: '/node_modules/pdfjs-dist/cmaps/',
        }}
        onPageChange={e => handlePdfPageChange(e)}
        initialPage={currentPage}
      />
    </Worker>
  );
};

PdfViewer.propTypes = {
  url: PropTypes.string.isRequired,
  handlePdfPageChange: PropTypes.func.isRequired,
  pageNavigationPluginInstance: PropTypes.any.isRequired,
  jumpToPagePluginInstance: PropTypes.any.isRequired,
};
export default memo(PdfViewer);
